<template>
    <div
        class="md slider"
        @mouseenter="clearTimer"
        @mouseleave="autoSlider"
    >
        <div class="ctrl-area">
            <div class="btns">
                <ul>
                    <li class="prev"><a href="#" :style="'z-index: '+ (length + 1)" @click.prevent="slider((sliderIndex - 1 + length) % length)"></a></li>
                    <li class="next"><a href="#" :style="'z-index: '+ (length + 1)" @click.prevent="slider((sliderIndex + 1 + length) % length)"></a></li>
                </ul>
            </div>
            <div class="dots" :style="'z-index: '+ (length + 1)">
                <ul>
                    <li
                        v-for="n in length"
                        :key="n"
                        :class="[n - 1 === sliderIndex? 'is-active': '']"
                    >
                        <a href="#" @click.prevent="slider(n - 1)"></a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="slider-area">
            <ul>
                <template v-for="(item, index) in data">
                    <li
                        :class="[sliderIndex === index? 'is-active': '']"
                        :style="'z-index: '+ getIndex(index)"
                        :key="item.sn"
                    >
                        <div
                            class="div"
                            @click.prevent="clickSlider(item)"
                        >
                            <div
                                v-if="item.image"
                                class="image"
                            >
                                <div class="mask"
                                    :style="getType(item.image) === 'image'? 'background-image: url('+ item.image +')': ''"
                                >
                                    <img v-if="getType(item.image) === 'image'" :src="item.image">
                                    <video v-else-if="getType(item.image) === 'video'" autoplay muted loop playsinline>
                                        <source :src="item.image" type="video/mp4">
                                    </video>
                                </div>
                            </div>
                            <div
                                v-if="item.caption"
                                class="caption"
                                :class="[item.straight, item.horizontal]"
                            >{{ item.caption }}</div>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
        <div class="arrow-area">
            <a @click.stop="scroll"></a>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            data: {
                type: Array,
                require: false,
                default: function(){
                    return []
                }
            },
        },
        data: function(){
            
            return {
                sliderIndex: 0,
                timer: null,
                delay: 8000
            }
        },
        computed: {
            length: function(){
                return this.data.length;
            },
            ulWidth: function(){
                return this.length * 100;
            },
            ulLeft: function(){
                return this.sliderIndex * -100;
            },
            liWidth: function(){
                return 100 / this.length;
            }
        },
        methods: {
            scroll: function(){

                window.scrollTo({
                    top: window.innerHeight,
                    behavior: 'smooth',
                });
            },
            getIndex: function(index){
                let _sliderIndex = this.sliderIndex,
                    _length = this.length;

                let _result = (index - _sliderIndex) % _length;

                if( _result <= 0 ) {
                    _result +=  _length;
                }

                return _result;
            },
            getType: function(url){
                let $typeList = {
                        video: ['.webm', '.mp4'],
                        image: ['.gif', '.jpeg', '.jpg', '.png', '.webp', '.svg', '.tiff'],
                    },
                    _url = url.toLowerCase();

                let _result = '';

                for( let _key in $typeList ) {

                    if( !_result ) {

                        let $list = $typeList[_key],
                            $target = $list.find(item => {
                                let $rule = new RegExp('\\'+ item +'\$'),
                                    $match = _url.match($rule);

                                return !!$match;
                            });

                        if( $target ) {
                            _result = _key;
                        }
                    }
                }
                
                return _result || 'other';
            },
            slider: function(n){
                this.$set(this, 'sliderIndex', n);
            },
            clickSlider: function(opt){
                this.$emit('sendEvent', 'clickSlider', opt);
            },
            clearTimer: function(){
                window.clearTimeout(this.timer);
            },
            autoSlider: function(){
                this.clearTimer();

                this.timer = setTimeout(() => {
                    let _sliderIndex = this.sliderIndex,
                        _length = this.length;

                    let _index = (_sliderIndex + 1 +_length) % _length;
                    
                    this.slider(_index);

                    this.autoSlider();

                }, this.delay);
            },
        },
        created: function (){
            this.autoSlider();
        },
    }
</script>

<style scoped lang="scss">

    .md.slider {
        $btn-size: 42px;

        position: relative;
        overflow: hidden;
        z-index: 1;
        border-radius: 0;

        &:hover {

            .ctrl-area {

                .btns {

                    ul {
                        
                    }

                    li {
                        
                        &.prev {

                            a {
                                left: $interval-l;
                            }
                        }

                        &.next {

                            a {
                                right: $interval-l;
                            }
                        }
                    }
                }
            }
        }

        .slider-area {

            ul {
                position: relative;
                height: 100vh;
            }

            li {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                // display: block;

                &.is-active {
                    animation-duration: 8s;
                    animation-name: animate-in;
                }
            }

            @keyframes animate-in {

                0% {
                    opacity: 0;
                    transform: scale(1.2, 1.2) rotate(0);
                }

                40% {
                    opacity: 1;
                }

                100% {
                    transform: scale(1, 1);
                }
            }

            /*a*/.div {
                // position: relative;
                // display: block;
            }

            .image {

                .mask {
                    position: absolute;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    transition: $transition;
                }
            
                img {
                    display: none;
                    // width: 100%;
                    // display: block;
                }

                video {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .caption {
                position: absolute;
                bottom: $interval-xxl;
                left: $interval-xxl;
                font-size: 4em;
                color: $black;
                text-shadow: 0 0 $interval-s $white;

                @include media('pad') {
                    font-size: 3em;
                }

                @include media('phone') {
                    font-size: 2em;
                }

                &.left {
                    right: auto;
                    left: $interval-xxl;

                    @include media('pad') {
                        left: $interval-xl;
                    }

                    @include media('phone') {
                        left: $interval-l;
                    }
                }

                &.right {
                    right: $interval-xxl;
                    left: auto;

                    @include media('pad') {
                        right: $interval-xl;
                    }

                    @include media('phone') {
                        right: $interval-l;
                    }
                }

                &.top {
                    top: $interval-xxl;
                    bottom: auto;

                    @include media('pad') {
                        top: $interval-xl;
                    }

                    @include media('phone') {
                        top: $interval-l;
                    }
                }

                &.bottom {
                    top: auto;
                    bottom: $interval-xxl;

                    @include media('pad') {
                        bottom: $interval-xl;
                    }

                    @include media('phone') {
                        bottom: $interval-l;
                    }
                }
            }
        }

        .ctrl-area {

            .btns {
                display: block;

                ul {
                    
                }

                li {
                    
                    &.prev {

                        a {
                            left: -1 * $btn-size;

                            &::before {
                                content: '\e5c4';
                            }
                        }
                    }

                    &.next {

                        a {
                            right: -1 * $btn-size;

                            &::before {
                                content: '\e5c8';
                            }
                        }
                    }
                }

                a {
                    position: absolute;
                    display: block;
                    cursor: pointer;
                    top: 50%;
                    margin-top: -0.5 * $btn-size;
                    transition: $transition;

                    &:hover {

                        &::before {
                            opacity: $opacity-vh;
                        }
                    }

                    &::before {
                        @extend %font-pseudo;
                        display: block;
                        width: $btn-size;
                        height: $btn-size;
                        line-height: $btn-size;
                        text-align: center;
                        color: $white;
                        border-radius: $btn-size;
                        background-color: $major-color;
                        opacity: $opacity-m;
                        font-size: $font-size-xxl;
                        transition: $transition;
                    }
                }
            }

            .dots {
                position: absolute;
                left: 0;
                right: 0;
                bottom: $interval-l;

                @include media('mobile') {
                    bottom: $interval-s;
                }

                ul {
                    text-align: center;                    
                }

                li {
                    display: inline-block;
                    padding: 0 5px;

                    &.is-active {

                        a {
                            background-color: $major-color;
                            width: $interval-xxl;
                        }
                    }
                }

                a {
                    display: block;
                    width: $interval-xl;
                    height: $interval-s;
                    border-radius: $border-radius;
                    background-color: $white;
                    transition: $transition;
                    box-shadow: 0 0 $interval-s $gray;
                    opacity: $opacity-h;

                    @include media('mobile') {
                        width: $interval-xxl;
                        height: $interval-m;
                    }

                    &:hover {
                        width: $interval-xxl;
                    }
                }
            }
        }

        .arrow-area {
            $size: 30px;

            position: absolute;
            left: 50%;
            width:  $size;
            height:  $size;
            margin-left: $size * -0.5;
            bottom: 80px;
            z-index: 11;
            animation-duration: 1s;
            animation-name: bump;
            animation-iteration-count: infinite;
            animation-direction: alternate;
            color: $deep;

            a {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                text-align: center;
                cursor: pointer;

                &:before {
                    content: '\f1e3';
                    @extend %font-pseudo;
                    font-size: $size;
                    line-height: $size;
                }

                &:hover {
                    color: $major-color;
                }
            }
        }

        @keyframes bump {

            from {
                bottom: 80px;
                color: $deep;
            }

            to {
                bottom: 70px;
                color: $major-color;
            }
        }

        ul {
            @extend %reset;
        }

        li {
            
        }
    }
</style>
